/* Phone Mask */
function phoneMask (phone) {
  return phone.replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{2})(\d)/, '$1) $2')
    .replace(/(\d{4})(\d{1,5})/, '$1-$2')
    .replace(/(-\d{5})\d+?$/, '$1')
}

/* Phone Mask */
function handleInput (e) {
  e.target.value = phoneMask(e.target.value)
}

function handlingSMSFooterError() {
  console.log(`handling SMS field error...`)
}

function handlingSMSFooterSuccess() {
  const smsInput = document.getElementById('listrak-sms-form-input')
  const smsSubmit = document.getElementById('listrak-sms-form-submit')
  const smsSuccess = document.querySelector('.listrak-sms-form-submit-success')
  smsInput && smsInput.classList.add('hidden')
  smsSubmit && smsSubmit.classList.add('hidden')
  smsSuccess && smsSuccess.classList.add('active')
}

/* Submit Form */
function validateSubmitSMSField(event) {
  event.preventDefault()
  const listrakFooterSMSData = _ltk?.Signup?.GetSavedSubscriberData()?.lists?.footerSMS
  const phoneNumber = listrakFooterSMSData && listrakFooterSMSData.ltkEmail
  if (phoneNumber) {
    handlingSMSFooterSuccess()
  } else {
    handlingSMSFooterError()
  }

}

const phoneInput = document.querySelector('#listrak-sms-form-input');
const footerContainer = document.getElementById('listrak-footer-container');
const submitButton = document.querySelector('.listrak-sms-form-submit');

if (phoneInput) {
  phoneInput.addEventListener('input', handleInputPhone);
  phoneInput.addEventListener('focus', handleFocusPhone);
}

function handleInputPhone(event) {
   let inputValue = event.target.value.trim().replace(/\D/g, '');

    if (!inputValue.startsWith('1')) {
        inputValue = '1' + inputValue;
    }

    const formattedValue = inputValue.slice(0, 1) + inputValue.slice(1, 4) + inputValue.slice(4, 7) + inputValue.slice(7, 11);

    event.target.value = formattedValue;

    const isValidUSPhoneNumber = /^\+1\d{10}$/.test(formattedValue);
    if (!isValidUSPhoneNumber || !/^\+?[0-9]*$/.test(event.target.value)) {
        event.target.classList.add('error');
    } else {
        event.target.classList.remove('error');
        if (footerContainer) footerContainer.classList.remove('sms-error');
    }
}

function handleFocusPhone(event) {
    let inputValue = event.target.value.trim().replace(/\D/g, '');

    if (!inputValue.startsWith('1')) {
        event.target.value = '1' + inputValue;
    }
}

function phoneValidation(event) {
    event.preventDefault();

    if (!phoneInput) return false;

    let inputValue = phoneInput.value.trim().replace(/\D/g, '');
    const isValidUSPhoneNumber = /^\d{11}$/.test(inputValue);

    const areaCode = inputValue.substring(1, 4);

    const regexAreaCode = /^[2-9][0-9]{2}$/;
    const isValidAreaCode = regexAreaCode.test(areaCode);

    if (!isValidUSPhoneNumber || !isValidAreaCode) {
        phoneInput.classList.add('error');
        if (footerContainer) footerContainer.classList.add('sms-error');
        return false;
    } else {
        phoneInput.classList.remove('error');
        if (footerContainer) footerContainer.classList.remove('sms-error');
        return true;
    }
}

document.addEventListener('DOMContentLoaded', () => {
  /* Form submit */
  const submitSMS = document.getElementById('listrak-sms-form-submit')
  submitSMS && submitSMS.addEventListener('click', function(event) {
    
    if(phoneValidation(event)){
       validateSubmitSMSField(event)
    }
   
  })

})
